import { postUserQuizAttempt } from "../endpoints/api"

const useUserAttempts = () => {

    const logQuizAttempt = async (uuid: string, artistId: string) => {
        const body = {
          uuid,
          artistId,
          source: "web"
        }
        try {
          const resp = await postUserQuizAttempt(body)
          if (resp && resp.data && resp.data.success) {
            console.log("Attempt logged")
          }
        } catch (error) {
          console.error("Error when logging the attempt", error)
        }
      }

    return {
        logQuizAttempt
    }
};

export default useUserAttempts;
